import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Container,
  Grid,
  Paper,
  Popover,
  RadioGroup,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Carousel } from 'react-responsive-carousel';
import ScreenBackV2 from '../Components/ScreenBackV2';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import CartAndAddressComponent from '../Components/CartAndAddressComponent';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { OperationType, unitCaseEnum } from '../../utils/settings';

function ProductDescription() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { productData } = state;
  const [bookingDetails, setBookingDetails] = useState({
    qty: 0,
    packaging: null,
  });

  const {
    addedUserList,
    selectedStp,
    isPaintFlow,
    isFmcgFlow,
    isSecondaryOrder,
    userIndex,
    booking_editorder_details,
  } = useSelector((state) => {
    return {
      addedUserList: state.bcmOrderReducer.addedUserList,
      selectedStp: state.bcmOrderReducer.selectedStp,
      isPaintFlow: state.bcmOrderReducer.isPaintFlow,
      isFmcgFlow: state.bcmOrderReducer.isFmcgFlow,
      isSecondaryOrder: state.bcmOrderReducer.isSecondaryOrder,
      userIndex: state.fmcgReducer.userIndex,
      booking_editorder_details:
        state.bcmOrderReducer.booking_editorder_details,
    };
  });
  const CheckSelectedQuantity = () => {
    const foundItem = selectedStp?.products?.find(
      (item) => item?.product_id === productData?.product_id
    );
    setBookingDetails((prev) => ({
      ...prev,
      qty: foundItem ? foundItem.qty : 0,
    }));
  };
  
  useEffect(() => {
    if (selectedStp && productData) {
      CheckSelectedQuantity();
    }
  }, [selectedStp, productData]);


  const sizes = !(isSecondaryOrder && isFmcgFlow)
    ? [{ label: 'Case', value: 1 }]
    : [
        { label: 'Case', value: 1 },
        { label: 'Unit', value: 2 },
      ];
  const [selectedSize, setSelectedSize] = useState(sizes[0].value);
  const onAddToBag = () => {
    if (state?.isFromEditOrderDetails) {
      const shipToParty = booking_editorder_details.shipment_details.filter(
        (item) =>
          item.ship_to_party_info.company_info.id === state.ship_to_party_id,
      )[0];

      const obj = {
        ...shipToParty,
        product_summary_info: [
          ...shipToParty.product_summary_info,
          {
            name: productData.name,
            product_id: productData.product_id,
            operation_type: OperationType['ADD'],
            pending: {
              quantity_in_metric_ton: Number(bookingDetails.qty),
              multiplier: productData.multiplier,
              unit: selectedSize === unitCaseEnum['UNIT'] ? 'Unit' : 'Case(s)',
            },
            price_info: {
              price:
                selectedSize === unitCaseEnum['UNIT']
                  ? Number(productData.meta_data.price.rlp)
                  : Number(productData.meta_data.price.dlp),
              unit: '₹',
            },
            delivered: {
              quantity_in_bags: 0,
              quantity_in_metric_ton: 0,
              multiplier: productData.multiplier,
              quantity: 0,
              unit: selectedSize === unitCaseEnum['UNIT'] ? 'Unit' : 'Case(s)',
            },
          },
        ],
      };
      dispatch({
        type: 'ADD_PRODUCT_EDIT_PO_BOOKING_DETAILS',
        data: obj,
      });

      navigate(-2);
    } else {
      if (isPaintFlow && addedUserList.length === 0) {
        return toast.error(
          'Please add delivery details to add products to cart',
        );
      } else {
        if (selectedSize === null) {
          return toast.error('Please Select Packaging');
        }
        if (bookingDetails.qty == 0 || bookingDetails.qty == null) {
          return toast.error('Please Enter Quantity');
        }
        if (isNaN(bookingDetails.qty)) {
          return toast.error('Please Enter  Quantity in Numbers ');
        }

        const user = addedUserList[userIndex];
        const productObj = {
          product_size: selectedSize,
          product_id: productData.product_id,
          product_multiplier: Number(productData.meta_data.multiplier),
          qty: !isSecondaryOrder
            ? Number(bookingDetails.qty)
            : selectedSize === unitCaseEnum['UNIT']
            ? Number(bookingDetails.qty)
            : Number(bookingDetails.qty * productData?.meta_data?.Case_Size),
          product_data: productData,
        };

        if (user.products && user.products.length > 0) {
          const index = user?.products?.findIndex(
            (prev) => prev.product_id === productObj.product_id,
          );
          const productList = user.products;
          if (index !== -1) {
            productObj.quantity += productList[index].quantity;
            productList[index] = productObj;
            user.products = productList;
          } else {
            user.products = [...user.products, productObj];
          }
        } else {
          user.products = [productObj];
        }
        const list = [...addedUserList];
        list.splice(userIndex, 1, user);
        dispatch({
          type: 'SET_USER_LIST',
          data: list,
        });

        return toast.success('Product added to cart');
      }
    }
  };
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '2rem',
          height: window.innerHeight,
          overflowY: 'auto',
          backgroundColor: '#f5f5f5',
        }}
      >
        {' '}
        <Stack
          direction={'row'}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            mb: '1.5rem',
          }}
        >
          <Stack
            display={'flex'}
            direction={'row'}
            spacing={2}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <ScreenBackV2
              color={'primary'}
              fontSize={'large'}
            />
            <Typography
              variant='h5'
              style={{
                fontWeight: 'bold',
              }}
            >
              Product Details
            </Typography>
          </Stack>
          <Stack>
            <CartAndAddressComponent
              hideDeliveryDetails={state?.hideDeliveryDetails}
            />
          </Stack>
        </Stack>
        <Paper>
          <Stack direction={'row'}>
            <Box
              sx={{
                maxHeight: '20%',
                width: '40%',
              }}
            >
              <Carousel
                useKeyboardArrows={true}
                autoPlay={true}
                showStatus={false}
                showIndicators={true}
                infiniteLoop={true}
              >
                {productData.product_images.map((url, index) => (
                  <img
                    alt='sample_file'
                    src={url}
                    key={index}
                  />
                ))}
              </Carousel>
            </Box>
            <Stack sx={{ width: '70%', pt: '2rem', pr: '2rem', ml: '2rem' }}>
              <Typography
                variant='h6'
                style={{ fontWeight: 'bold' }}
              >
                {productData.name}
              </Typography>
              <Typography
                variant='subtitle1'
                style={{ marginBottom: '1rem' }}
              >
                {productData.sub_product}
              </Typography>
              <Stack direction={'row'}>
                {/* <ThemeProvider> */}
                <Typography
                  gutterBottom
                  variant='subtitle1'
                  component='div'
                  sx={{
                    textDecoration: 'line-through',
                    fontWeight: 'bold',
                  }}
                >
                  ₹ {productData.meta_data.MRP}
                </Typography>
                {/* </ThemeProvider> */}

                <Typography
                  variant='subtitle1'
                  color='text.secondary'
                  sx={{
                    ml: '0.5rem',
                    color: '#1fd655',
                    fontWeight: 'bold',
                  }}
                  aria-owns={open ? 'mouse-over-popover' : undefined}
                  aria-haspopup='true'
                  onMouseEnter={handlePopoverOpen}
                  onMouseLeave={handlePopoverClose}
                >
                  ₹{' '}
                  {!isSecondaryOrder
                    ? productData.meta_data.price.dlp
                    : productData.meta_data.price.rlp}
                </Typography>
                <Popover
                  id='mouse-over-popover'
                  sx={{
                    pointerEvents: 'none',
                  }}
                  open={open}
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  onClose={handlePopoverClose}
                  disableRestoreFocus
                >
                  <Stack
                    direction={'column'}
                    spacing={'2'}
                    sx={{ p: 2 }}
                  >
                    {productData?.meta_data?.price_breakup_info.map((item) => (
                      <Typography
                        variant='subtitle1'
                        sx={{
                          ml: '0.5rem',
                          fontWeight: 'bold',
                        }}
                      >
                        {item.display_name} : {item.label}
                      </Typography>
                    ))}
                  </Stack>
                </Popover>
              </Stack>
              <Stack>
                <Typography
                  variant='body1'
                  style={{
                    marginBottom: '0.5rem',
                    fontWeight: 'bold',
                    marginTop: '1rem',
                  }}
                >
                  Description
                </Typography>
                <Typography
                  variant='body1'
                  style={{ marginBottom: '1rem' }}
                >
                  {productData.product_description}
                </Typography>
              </Stack>

              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Stack>
                  <Typography
                    variant='body1'
                    style={{
                      // marginBottom: '0.5rem',
                      fontWeight: 'bold',
                      marginTop: '1rem',
                    }}
                  >
                    Case Size
                  </Typography>
                  <Typography
                    variant='body1'
                    style={{ marginBottom: '1rem' }}
                  >
                    {productData.meta_data?.Case_Size}
                  </Typography>
                </Stack>
                <Stack>
                  <Typography
                    variant='body1'
                    style={{
                      // marginBottom: '0.5rem',
                      fontWeight: 'bold',
                      marginTop: '1rem',
                    }}
                  >
                    Shelf Life
                  </Typography>
                  <Typography
                    variant='body1'
                    style={{ marginBottom: '1rem' }}
                  >
                    {productData.meta_data?.Shelf_Life}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction={'row'}
                sx={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Stack>
                  <Typography
                    variant='body1'
                    style={{
                      // marginBottom: '0.5rem',
                      fontWeight: 'bold',
                      marginTop: '1rem',
                    }}
                  >
                    GTIN/EAN
                  </Typography>
                  <Typography
                    variant='body1'
                    style={{ marginBottom: '1rem' }}
                  >
                    {productData.meta_data?.GTIN_EAN}
                  </Typography>
                </Stack>

                <Stack>
                  <Typography
                    variant='body1'
                    style={{
                      // marginBottom: '0.5rem',
                      fontWeight: 'bold',
                      marginTop: '1rem',
                    }}
                  >
                    Type
                  </Typography>
                  <Typography
                    variant='body1'
                    style={{ marginBottom: '1rem' }}
                  >
                    {productData.meta_data?.Type}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
          </Stack>
        </Paper>
        <Card sx={{ mt: '2rem', mb: '2rem' }}>
          <CardHeader
            title='Booking Details'
            sx={{ backgroundColor: '#f5f5f5' }}
          />
          <CardContent>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Select Packaging:
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <RadioGroup row>
                  {sizes.map((item) => {
                    return (
                      <Button
                        variant={'outlined'}
                        sx={{
                          color:
                            item.value === selectedSize ? '#F49D3F' : '#B0B0B0	',
                          borderColor:
                            item.value === selectedSize ? '#F49D3F' : '#B0B0B0	',
                          mr: '1rem',
                          width: '5rem',
                        }}
                        onClick={() => {
                          setSelectedSize(item.value);
                        }}
                      >
                        {item.label}
                      </Button>
                    );
                  })}
                </RadioGroup>
              </Grid>
            </Grid>
            <Grid container>
              <Grid
                item
                xs={12}
                md={3}
                alignContent='center'
              >
                <Typography
                  variant='h6'
                  fontSize={15}
                >
                  Enter Quantity
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                md={5}
                alignContent='center'
              >
                <TextField
                  label='Enter Quantity'
                  name='qty'
                  value={bookingDetails.qty}
                  onChange={(e) =>
                    setBookingDetails({
                      ...bookingDetails,
                      qty: e.target.value,
                    })
                  }
                  fullWidth
                  margin='normal'
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='contained'
            style={{
              backgroundColor: '#F59C1E',
              paddingLeft: '5rem',
              paddingRight: '5rem',
              borderRadius: '0.5rem',
              marginRight: '2rem',
              fontWeight: 'bold',
              marginBottom: '2rem',
            }}
            onClick={() => onAddToBag()}
          >
            {state?.isFromEditOrderDetails ? 'Add Product' : 'Add To Bag'}
          </Button>
        </Box>
      </Container>
    </>
  );
}

export default ProductDescription;
